import {Component, Inject, OnInit} from '@angular/core';
import {FavoriteList} from '@models/favorite';
import {EMPTY_FAVORITE_LIST} from '@models/empty';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {FormService} from '@services/form.service';
import {AlertService} from '@services/alert.service';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-share-popup',
    templateUrl: './share-popup.component.html',
    styleUrls: ['./share-popup.component.scss']
})
export class SharePopupComponent implements OnInit {

    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    shareUserIds: any[] = [];
    loading = false;
    loadingUsers = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<SharePopupComponent>,
        public formService: FormService,
        private alertService: AlertService,
        public authenticationService: AuthenticationService) {

        this.favoritesList = Object.assign({}, data.favoritesList);
    }

    ngOnInit() {
        this.adService.getFavoritesListShare(this.favoritesList.id).subscribe(result => {
            result.users.forEach(u => {
                if (u.id != this.authenticationService.currentUser.id) {
                    let t = {id: u.id, name: u.firstname + ' ' + u.lastname, share: false};
                    result.current_shares.forEach(r => {
                        if (r.user_id == u.id) {
                            t.share = true;
                        }
                    });
                    this.shareUserIds.push(t);
                }
            });
            this.loadingUsers = false;
        }, error => {

        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.loading = true;
        let ids = [];
        this.shareUserIds.forEach(u => {
            if (u.share == true) {
                ids.push(u.id);
            }
        });

        this.adService.favoritesListShare(this.favoritesList.id, ids).subscribe(result => {
            this.dialogRef.close(ids);
        }, error => {
            this.alertService.error('Une erreur est survenue pendant l\'enregistrement de l\'utilisateur. Veuillez rééssayer ultérieurement.');
            console.log(error);
            this.loading = false;
        });
    }
}
